<template>
    <kiosk-org-unit-details :teamId="props.teamId" :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-org-unit-billing-details" class="mb-4" />

                <page-header>Billing Details</page-header>

                <org-unit-billing-email
                    class="mb-4"
                    :teamId="orgUnit.team_id"
                    :orgUnitId="orgUnit.id"
                    :billingEmail="orgUnit.billing_email"
                    :isEditable="isEditable"
                />

                <org-unit-billing-info
                    class="mb-4"
                    :teamId="orgUnit.team_id"
                    :orgUnitId="orgUnit.id"
                    :billingInformation="{
                        billing_company_legal_name: orgUnit.billing_company_legal_name,
                        billing_address: orgUnit.billing_address,
                        billing_address_line_2: orgUnit.billing_address_line_2,
                        billing_city: orgUnit.billing_city,
                        billing_state: orgUnit.billing_state,
                        billing_zip: orgUnit.billing_zip,
                        billing_country: orgUnit.billing_country,
                        billing_po_number: orgUnit.billing_po_number,
                    }"
                    :isEditable="isEditable"
                />

                <org-unit-stripe-customer v-if="stripeKey && isEditable" class="mb-4" :stripeId="orgUnit.stripe_id" />
            </div>
        </div>
    </kiosk-org-unit-details>
</template>

<script setup>
import KioskOrgUnitDetails from '~/components/kiosk/kiosk-org-units/details/KioskOrgUnitDetails.vue';
import { useOrgUnitDetails } from '~/components/kiosk/kiosk-org-units/composables/useOrgUnitDetails';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import OrgUnitBillingEmail from '~/components/settings/billing/OrgUnitBillingEmail.vue';
import OrgUnitBillingInfo from '~/components/settings/billing/OrgUnitBillingInfo.vue';
import OrgUnitStripeCustomer from '~/components/settings/billing/OrgUnitStripeCustomer.vue';
import { computed } from 'vue';

const { orgUnit } = useOrgUnitDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const stripeKey = Spark.stripeKey;
const isEditable = computed(() => orgUnit.value.is_billable);
</script>
